import { render, staticRenderFns } from "./PostServices.vue?vue&type=template&id=1fe04f7e&"
import script from "./PostServices.vue?vue&type=script&lang=js&"
export * from "./PostServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports